<template>
  <div>
    <TwoColumnText leftText="Index:" :rightText="index"></TwoColumnText>
    <TwoColumnText leftText="Serial Number:" :rightText="board.SerialNumber"></TwoColumnText>

    <div>
      <div style="width:30%;float:left;text-align:right">
        <div>Accelerometer Calibration:</div>
      </div>
      <div style="width:70%;float:left;padding-left:10px">
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">RMS Validation&nbsp;=&nbsp; </th>
              <td>{{board.RMSEValidAccel}}</td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Offsets&nbsp;=&nbsp; </th>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.AccelCal.Offsets[0]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.AccelCal.Offsets[1]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.AccelCal.Offsets[2]}}</td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <th rowspan="3" colspan="1" scope="rowgroup">Gain&nbsp;=&nbsp; </th>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.AccelCal.Gain[0]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.AccelCal.Gain[1]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.AccelCal.Gain[2]}}</td>
            </tr>
            <tr>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.AccelCal.Gain[3]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.AccelCal.Gain[4]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.AccelCal.Gain[5]}}</td>
            </tr>
            <tr>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.AccelCal.Gain[6]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.AccelCal.Gain[7]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.AccelCal.Gain[8]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <div style="width:30%;float:left;text-align:right">
        <div>CCS to ACS Calibration:</div>
      </div>
      <div style="width:70%;float:left;padding-left:10px">
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">RMS Validation&nbsp;=&nbsp; </th>
              <td>{{board.RMSEValidCCS_ACS}}</td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <th rowspan="3" colspan="1" scope="rowgroup">Transformation&nbsp;=&nbsp; </th>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CCS_ACSCal[0]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CCS_ACSCal[1]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CCS_ACSCal[2]}}</td>
            </tr>
            <tr>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CCS_ACSCal[3]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CCS_ACSCal[4]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CCS_ACSCal[5]}}</td>
            </tr>
            <tr>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CCS_ACSCal[6]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CCS_ACSCal[7]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CCS_ACSCal[8]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <div style="width:30%;float:left;text-align:right">
        <div>Camera Calibration:</div>
      </div>
      <div style="width:70%;float:left;padding-left:10px">
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">RMS Validation&nbsp;=&nbsp; </th>
              <td>{{board.RMSEValidCamCal}}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Image Rows&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.image_rows}}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Image Columns&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.image_cols}}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Image Channels&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.image_chans}}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Pixel Size&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.pixel_size_um}}μm</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Center x&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.cx}}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Center y&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.cy}}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Focal Length&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.flen_pixels}}pixels</td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Focal Length&nbsp;=&nbsp; </th>
              <td>{{board.CameraCal.flen_mm}}mm</td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <th rowspan="3" colspan="1" scope="rowgroup">Intrinsic Matrix&nbsp;=&nbsp; </th>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CameraCal.IM[0]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CameraCal.IM[1]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CameraCal.IM[2]}}</td>
            </tr>
            <tr>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CameraCal.IM[3]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CameraCal.IM[4]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CameraCal.IM[5]}}</td>
            </tr>
            <tr>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CameraCal.IM[6]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CameraCal.IM[7]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CameraCal.IM[8]}}</td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <th rowspan="1" colspan="1" scope="rowgroup">Distortion Coefficients&nbsp;=&nbsp; </th>
              <td style="border-left:1px solid black;padding-left:5px;">{{board.CameraCal.dist_coeffs[0]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CameraCal.dist_coeffs[1]}}</td>
              <td>{{board.CameraCal.dist_coeffs[2]}}</td>
              <td style="padding-left:5px;padding-right:5px;">{{board.CameraCal.dist_coeffs[3]}}</td>
              <td style="border-right:1px solid black;padding-right:5px;">{{board.CameraCal.dist_coeffs[4]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import TwoColumnText from './TwoColumnText.vue';

export default {
  components: {
    TwoColumnText,
  },

  props: {
    index: Number,
    board: Object,
  },
};
</script>
